module.exports = __webpack_public_path__ + "img/laboratorio_4-3.e84cff0d.jpg";